import React from 'react';
import { Users, Star } from 'lucide-react';

export const SocialProof = () => {
  return (
    <div className="flex items-center justify-center gap-4 text-xs text-gray-400">
      <div className="flex items-center gap-1">
        <Users className="h-3 w-3" />
        <span>Trusted by active investors</span>
      </div>
      <div className="flex items-center gap-1">
        <div className="flex">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-3 w-3 fill-yellow-400 text-yellow-400" />
          ))}
        </div>
        <span>Highly rated</span>
      </div>
    </div>
  );
};

export default SocialProof;
